module.exports = __webpack_public_path__ + "static/media/40.4c38eb4e.png";